module.exports = __webpack_public_path__ + "fonts/Kruti_Dev_10.377392a4.TTF";